import { Tooltip } from "@/components/ui/tooltip";
import { AccountListEntity } from "@/pages/accounts/schema/account.schema";
import { AppColors } from "@/styles/colors";
import { Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: AccountListEntity;
  handleDetail: (id: any) => void;
}

export const AccountActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Eye
        cursor="pointer"
        data-testid="account-actions-eye"
        onClick={() => handleDetail(item?.nroCuenta)}
      />
    </Tooltip>
  );
};
